// @flow

import { ApolloLink } from 'apollo-link';

import { createReduxAction } from 'app/common/apollo/ApolloLinkStateSync';

import type { Store } from 'redux';

// Why?
//
// As of Apollo Client 2.x, Redux is no longer used to store
// GraphQL managed client-side state.
//
// Furthermore, Redux actions are no longer dispatched when an
// Apollo query/mutation completes (carrying with it valuable data).
//
// So, this is an [Apollo Link](https://www.apollographql.com/docs/react/advanced/network-layer.html)
// which will `dispatch` a Redux action upon query/mutation responses.

const createReduxLink = (store: Store<any, any>) =>
  new ApolloLink((operation, forward) => {
    return forward(operation).map(data => {
      const action = createReduxAction(operation, data);
      store.dispatch(action);
      return data;
    });
  });

export default createReduxLink;
